import type { FaireProductEntity } from "../../entity_types/product";

export const p_feqscw4ghc: FaireProductEntity = {
  token: "p_feqscw4ghc",
  type: "product",
  name: "Personalized Name Retro Motel Keychain",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/16758f694f8b1978ceb189418589b0c13dd181220434cfb2f10b091bac9acb47.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b5e0ffb1ab31c7af4bec824bd3e716e87fdbcce5d161ba01a027004ac2b12131.jpeg",
    "https://cdn.faire.com/fastly/5e281af32aa5c3dd2342962833ac722edef1fb2a787c2dc33c06ffa9e187cfbc.jpeg",
    "https://cdn.faire.com/fastly/524e7498b6a5505f9bbd1f0cf145335d899624fbb51a900ce24ed47aa60d72e2.jpeg"
  ],
  priceDollars: 5.5,
  description: "Kindly note: If a white color is selected, the text will be black. For all other colors, the text will be white. Wood will be engraved.\n\nOur personalized retro motel keychain is the perfect accessory to add some fun and personality to your keys! Whether you're looking for a unique gift for your bridesmaids, a special present for Mother's Day, or just want to add some retro charm to your everyday routine, our keychain is the perfect choice.\n\nCrafted from high-quality acrylic and inspired by classic retro designs, our keychains are built to last and withstand the wear and tear of everyday use. With the ability to customize your keychain with your own text or design, you can create a one-of-a-kind accessory that's as unique as you are.\n\nThe vibrant colors and bold typography make it easy to spot your keys in a crowded bag or on a busy keyring, and the retro design is sure to turn heads.\n\n• Measures: 3.5\" H x 1.7\" W\n• Material: Acrylic",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:46.606Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
